import model from './model/text.js';

export default {
  model,
  actions: {
    trackShipment: {
      notes: 'Button text for tracking order with carrier',
      message: 'Track',
    },
  },
};
